import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Star, Heart, Sparkles } from 'lucide-react';

export default function Artikel15GeschenkeFrauen() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors">
            <ArrowLeft className="w-4 h-4" />
            Alle Ratgeber
          </Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4">
            <Calendar className="w-4 h-4" />
            <span>Aktualisiert: Februar 2026</span>
          </div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">
            15 einzigartige Geschenke für Frauen zu Eid
          </h1>
          <p className="text-lg text-white/80 leading-relaxed">
            Von luxuriösen Parfüms über eleganten Schmuck bis zu Wellness-Sets – 
            entdecke die schönsten Geschenkideen für Frauen zu Eid ul Fitr und Eid ul Adha.
          </p>
        </div>
      </section>

      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="prose prose-lg max-w-none">
            <p className="text-xl text-[#2C332E] leading-relaxed mb-8">
              Frauen zu beschenken kann eine Herausforderung sein – aber mit den richtigen Ideen 
              wird es zum Vergnügen. Ob für die Mutter, Schwester, Ehefrau oder Freundin: 
              Diese 15 Geschenkideen sind sorgfältig ausgewählt, um Eleganz, Wertschätzung 
              und islamische Werte zu vereinen.
            </p>

            <div className="bg-[#F5F5F0] rounded-2xl p-6 md:p-8 mb-12">
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">📖 Kategorien</h2>
              <ul className="space-y-2 text-[#4A5D4F]">
                <li><a href="#parfum" className="hover:underline">1. Düfte & Parfüms</a></li>
                <li><a href="#schmuck" className="hover:underline">2. Schmuck & Accessoires</a></li>
                <li><a href="#wellness" className="hover:underline">3. Wellness & Pflege</a></li>
                <li><a href="#mode" className="hover:underline">4. Mode & Hijab</a></li>
                <li><a href="#spirituell" className="hover:underline">5. Spirituelle Geschenke</a></li>
              </ul>
            </div>

            {/* Parfum Section */}
            <section id="parfum" className="mb-12">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center">
                  <Sparkles className="w-6 h-6 text-[#4A5D4F]" />
                </div>
                <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">
                  1. Düfte & Parfüms
                </h2>
              </div>
              
              <p className="text-[#4B5563] leading-relaxed mb-6">
                Parfüm ist ein klassisches und immer willkommenes Geschenk. Orientalische Düfte 
                haben eine besondere Bedeutung und passen perfekt zu Eid.
              </p>

              <div className="space-y-4 mb-6">
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">1. Swiss Arabian Parfum-Geschenkset</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Luxuriöses Set mit mehreren orientalischen Düften. Elegante Verpackung, 
                    perfekt als Geschenk. Enthält Oud, Moschus und florale Noten.
                  </p>
                  <p className="text-sm text-[#4A5D4F] font-medium mt-2">Ab 60,00 €</p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">2. RITUALS Velvet Oudh Set</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Vier luxuriöse Produkte für Bad, Körper und Raumduft. Der betörende Duft 
                    von Oud und orientalischen Noten verwöhnt alle Sinne.
                  </p>
                  <p className="text-sm text-[#4A5D4F] font-medium mt-2">Ab 69,90 €</p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">3. Attar-Öl Kollektion</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Konzentrierte, alkoholfreie Parfümöle. Traditionell und langanhaltend. 
                    Erhältlich in Rose, Jasmin, Amber und Oud-Varianten.
                  </p>
                  <p className="text-sm text-[#4A5D4F] font-medium mt-2">Ab 25,00 €</p>
                </div>
              </div>
            </section>

            {/* Schmuck Section */}
            <section id="schmuck" className="mb-12">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center">
                  <Heart className="w-6 h-6 text-[#4A5D4F]" />
                </div>
                <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">
                  2. Schmuck & Accessoires
                </h2>
              </div>

              <p className="text-[#4B5563] leading-relaxed mb-6">
                Schmuck ist ein zeitloses Geschenk, das Frauen über Jahre hinweg tragen und 
                in Erinnerung behalten. Von dezent bis auffällig – für jeden Geschmack.
              </p>

              <div className="space-y-4 mb-6">
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">4. Goldkette mit Anhänger</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Elegante Goldkette mit filigranem Anhänger – ein zeitloser Klassiker. 
                    Dezent genug für den Alltag, elegant genug für besondere Anlässe.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">5. Armband mit islamischer Kalligraphie</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Feines Armband mit eingravierten arabischen Worten wie "Bismillah" oder 
                    "Alhamdulillah". Bedeutungsvoll und wunderschön zugleich.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">6. Hochwertige Hijab-Pins</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Set aus eleganten Hijab-Nadeln mit Perlen oder Kristallen. Praktisch 
                    und dekorativ – ein durchdachtes Geschenk für Hijab-Trägerinnen.
                  </p>
                </div>
              </div>
            </section>

            {/* Wellness Section */}
            <section id="wellness" className="mb-12">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center">
                  <Sparkles className="w-6 h-6 text-[#4A5D4F]" />
                </div>
                <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">
                  3. Wellness & Pflege
                </h2>
              </div>

              <p className="text-[#4B5563] leading-relaxed mb-6">
                Nach dem anstrengenden Ramadan verdienen Frauen eine Auszeit. 
                Wellness-Geschenke zeigen Wertschätzung für Körper und Seele.
              </p>

              <div className="space-y-4 mb-6">
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">7. Home-Spa Geschenkset</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Badebomben, Körperöl, Gesichtsmaske und Kerzen – alles für einen 
                    entspannten Spa-Abend zu Hause nach dem Ramadan.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">8. Bio-Arganöl aus Marokko</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Reines Arganöl für Haut und Haar. Ein natürliches Luxusprodukt 
                    aus der orientalischen Tradition – pflegend und vielseitig.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">9. Duftkerzen-Set (Oud, Rose, Amber)</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Drei handgefertigte Duftkerzen mit orientalischen Düften. Schaffen 
                    eine gemütliche Atmosphäre und duften himmlisch.
                  </p>
                </div>
              </div>
            </section>

            {/* Mode Section */}
            <section id="mode" className="mb-12">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center">
                  <Gift className="w-6 h-6 text-[#4A5D4F]" />
                </div>
                <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">
                  4. Mode & Hijab
                </h2>
              </div>

              <div className="space-y-4 mb-6">
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">10. Seiden-Hijab-Set</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Luxuriöse Seiden-Hijabs in verschiedenen Farben. Fließend, elegant 
                    und perfekt für besondere Anlässe wie Eid.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">11. Elegante Abaya</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Eine festliche Abaya mit dezenten Verzierungen oder Stickereien. 
                    Das perfekte Outfit für das Eid-Gebet und Familienbesuche.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">12. Designer-Handtasche</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Eine hochwertige Handtasche in neutraler Farbe. Praktisch für 
                    den Alltag und elegant genug für besondere Anlässe.
                  </p>
                </div>
              </div>
            </section>

            {/* Spirituelle Geschenke */}
            <section id="spirituell" className="mb-12">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center">
                  <Heart className="w-6 h-6 text-[#4A5D4F]" />
                </div>
                <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E]">
                  5. Spirituelle Geschenke
                </h2>
              </div>

              <div className="space-y-4 mb-6">
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">13. Quran mit Samt-Einband</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Eine wunderschöne Quran-Ausgabe mit weichem Samt-Einband in 
                    Pastellfarben. Perfekt für Frauen, die gerne rezitieren.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">14. Gebets-Set für Frauen</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Eleganter Gebetsteppich, passende Gebetskleidung und Tasbih 
                    in einer schönen Geschenkbox. Alles für das Gebet vereint.
                  </p>
                </div>
                <div className="bg-[#F5F5F0] rounded-xl p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <Star className="w-4 h-4 text-[#D4C5A9]" />
                    <h4 className="font-medium text-[#2C332E]">15. Islamische Wandkunst</h4>
                  </div>
                  <p className="text-sm text-[#4B5563]">
                    Kunstdruck oder Kalligraphie mit einem bedeutungsvollen Vers 
                    oder Dua. Verschönert das Zuhause und erinnert an Allah.
                  </p>
                </div>
              </div>
            </section>

            {/* Conclusion */}
            <section className="mb-12">
              <h2 className="font-serif text-2xl md:text-3xl font-medium text-[#2C332E] mb-6">
                Fazit: Das perfekte Geschenk für sie
              </h2>
              <p className="text-[#4B5563] leading-relaxed mb-4">
                Das beste Geschenk zeigt, dass Sie die Frau kennen und schätzen. Ob luxuriös 
                oder praktisch, spirituell oder modisch – wichtig ist die Intention und die 
                Liebe dahinter.
              </p>
              <p className="text-xl text-[#4A5D4F] font-medium">
                Eid Mubarak! 🌙
              </p>
            </section>

            {/* Internal Links */}
            <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
              <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
              <ul className="space-y-2">
                <li><Link to="/ratgeber/10-geschenke-maenner" className="text-[#4A5D4F] hover:underline">→ 10 Geschenke für Männer</Link></li>
                <li><Link to="/ratgeber/25-geschenke-kinder" className="text-[#4A5D4F] hover:underline">→ 25 beste Eid Geschenke für Kinder</Link></li>
                <li><Link to="/ratgeber/beste-eid-geschenke-2026" className="text-[#4A5D4F] hover:underline">→ Die besten Eid Geschenke 2026</Link></li>
              </ul>
            </div>

            <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
              <h3 className="font-serif text-2xl font-medium text-white mb-4">
                Geschenke für Frauen entdecken
              </h3>
              <Link
                to="/geschenke/frauen"
                className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors"
              >
                Jetzt stöbern
                <Gift className="w-5 h-5" />
              </Link>
            </div>
          </div>
        </div>
      </article>
    </main>
  );
}
